import React from "react";
import styled from "@emotion/styled";

import { screenLargerThan } from "@/styles";

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
  font-size: 0.75rem;
  font-weight: 500;
`;

const StyledIconContainer = styled.div`
  width: 8rem;
  aspect-ratio: 1/1.3;
  border: 2px solid var(--clr-neutral-solid-900, #0d0d12);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10rem;
  cursor: pointer;
  transition: border-color 240ms ease;

  &:hover {
    border-color: var(--clr-primary-100, #5f57ff);
  }

  ${screenLargerThan.tablet} {
    width: 11rem;
  }
`;

const Feature: React.FC<{
  title: string;
  icon?: string;
  className?: string;
  variant?: "light" | "dark";
}> = ({ title, icon, className, variant = "dark" }) => {
  return (
    <StyledContainer className={className}>
      <StyledIconContainer
        style={
          variant === "light"
            ? {
                borderColor: "#fff",
              }
            : {}
        }
      >
        {icon}
      </StyledIconContainer>
      {title}
    </StyledContainer>
  );
};

export default Feature;
